module.exports = __webpack_public_path__ + "img/briefcase-fill.4807e6a5.svg";